import { usePortal } from '@web-ui-kit/hooks.use-portal'
import Icon from '@web-ui-kit/icon'
import useNavigationOptions from '../../hooks/useNavigationOptions'
import * as Sc from './NavigationRail.style'
import { LogoEdubookLandscapeGradient } from 'assets/icons/LogoEdubookLandscapeGradient'
import { isMladinskaPublisher } from 'utils'

const NavigationRail = () => {
  const { render } = usePortal('sidebar-desktop')
  const { mainOptions, publishers } = useNavigationOptions()
  const isMladinska = isMladinskaPublisher(publishers)
  return render(
    <Sc.CustomSidebar
      logo={
        !isMladinska ? (
          <Sc.LogoContainer>
            <Icon height={32} icon='edubookFavText' width={32} />
            <Sc.HoverLogoContainer>
              <Icon height={32} icon='edubookFavBook' width={32} />
              <LogoEdubookLandscapeGradient />
            </Sc.HoverLogoContainer>
          </Sc.LogoContainer>
        ) : null
      }
      positionTooltip='right'
      topOptions={mainOptions}
    />
  )
}

export default NavigationRail
